import React from 'react';
import CardStoreList from './CardStoreList';
import { useOrderTypeContext } from '../../Contexts/OrderTypeContext';
import { GoogleMap, InfoWindow, LoadScript, OverlayView } from '@react-google-maps/api';
import { TbMapPinFilled } from 'react-icons/tb';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import { ImSpinner8 } from 'react-icons/im';

interface StoreListMapGoogleProps {
    loading?: boolean;
    className?: string;
    isInDrawer?: boolean;
    onClickStore: (store: any) => void;
    onClose: () => void;
    stores: any[];
    selected: any;
}

const StoreListMapGoogle = ({ loading, stores, onClickStore, onClose, selected }: StoreListMapGoogleProps) => {

    const { orderType } = useOrderTypeContext();
    const { company } = useLayoutContext();

    const [ lastSelected, setLastSelected ] = React.useState<any>(null);

    if (!company?.google_maps) return null;

    return (
        loading ? (
            <div className='flex items-center justify-center h-full'>
                <ImSpinner8 className="animate-spin" />
            </div>
        ) : (
            <div className='h-full w-full'>
                <LoadScript googleMapsApiKey={company?.google_maps}>
                    <GoogleMap
                        mapContainerStyle={{ width: '100%', height: '100%' }}
                        center={{
                            lat: Number(lastSelected?.latitude || stores[0].latitude),
                            lng: Number(lastSelected?.longitude || stores[0].longitude)
                        }}
                        zoom={11}
                        options={{
                            disableDefaultUI: false,
                            zoomControl: false,
                            fullscreenControl: false,
                            streetViewControl: true,
                            mapTypeControl: false,
                        }}
                    >
                        {stores.map((store: any) => (
                            <OverlayView
                                key={store.id}
                                position={{ lat: Number(store.latitude), lng: Number(store.longitude) }}
                                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                            >
                                <div
                                    className='flex flex-col items-center cursor-pointer group relative rounded-full'
                                    onClick={() => onClickStore(store)}
                                    title={store.name}
                                >
                                    <TbMapPinFilled size={40} className='text-custom-primary hover:opacity-90 transition-all ease-in-out' />
                                </div>
                            </OverlayView>
                        ))}

                        {selected && (
                            <InfoWindow
                                position={{ lat: Number(selected.latitude), lng: Number(selected.longitude) }}
                                onCloseClick={() => {
                                    setLastSelected(selected);
                                    onClose();
                                }}
                                onLoad={(iw) => {
                                    const container = document.createElement('div');
                                    container.style.fontWeight = '800';
                                    container.style.fontSize = '15px';
                                    container.style.paddingRight = '20px';
                                    container.style.paddingBottom = '5px';
                                    container.classList.add('text-custom-primary');
                                    container.innerText = selected?.name;
                                    iw.setOptions({ headerContent: container });
                                }}
                            >
                                <CardStoreList
                                    isGoogleMaps={true}
                                    store={selected}
                                    onCardClick={() => onClickStore(selected)}
                                    orderType={orderType}
                                    showServices={true}
                                    enableCardClick={false}
                                />
                            </InfoWindow>
                        )}
                    </GoogleMap>
                </LoadScript>
            </div>
        )
    );
}

export default StoreListMapGoogle;
